import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { Category } from "../../types/types";

const initialState: Category[] = []

export const fetchCategories = createAsyncThunk('fetchCategories', 
        async ()=>{
            const responce = await axios.get('https://api.escuelajs.co/api/v1/categories')
            return responce.data
        }
)

const category = createSlice({
    name: 'category',
    initialState,
    reducers: {

    },
    extraReducers: (build) => {
        build.addCase(fetchCategories.fulfilled, (state, action)=> {
            return action.payload
        })
    }
})

export const categoryReducer = category.reducer